import { render } from "./AppealsTab.vue?vue&type=template&id=2a77f87e&scoped=true"
import script from "./AppealsTab.vue?vue&type=script&lang=js"
export * from "./AppealsTab.vue?vue&type=script&lang=js"

import "./AppealsTab.vue?vue&type=style&index=0&id=2a77f87e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a77f87e"]])

export default __exports__